import {
  ComplianceIndividualProfileInput,
  ComplianceInstitutionProfileInput,
  ComplianceJointProfileInput,
  IndividualAccountTypeEnum,
  InstitutionAccountTypeEnum,
  JointAccountTypeEnum,
} from "../../../graphql/supergraphTypes";
import {
  buildJointDomicileAddresses,
  getSafeDate,
  profileAddressesToAddresses,
} from "../../common/ProfileManagement/profile_utils";
import { DeclarationFormValues, DeclarationProfileType } from "./types";

export const getDeclarationFormInitialValues = (
  profile?: DeclarationProfileType | null,
  ownershipPercentage?: number | null,
): DeclarationFormValues => {
  return {
    accountType: undefined,
    firstName: profile?.firstName || "",
    middleName: profile?.middleName || "",
    lastName: profile?.lastName || "",
    legalBusinessName: profile?.legalName || "",
    ownershipPercentage: ownershipPercentage ?? undefined,
  };
};

export const prepareIndividualPayload = (
  caseId: number,
  values: DeclarationFormValues,
  profile?: DeclarationProfileType | null,
): ComplianceIndividualProfileInput => {
  const hasOwnershipPercentage = values.ownershipPercentage && values.ownershipPercentage > 0;

  return {
    caseId: caseId,
    firstName: values.firstName || "",
    middleName: values.middleName,
    lastName: values.lastName || "",
    accountType: values.accountType as IndividualAccountTypeEnum,
    dateOfBirth: getSafeDate(profile?.dateOfBirth),
    taxId: profile?.taxIdUnencrypted,
    taxIdType: profile?.taxIdType,
    relationshipType: profile?.parentRelationships?.map(
      (relationship) => relationship.relationshipType,
    ),
    ...(hasOwnershipPercentage && {
      ownershipPercentage: values.ownershipPercentage,
    }),
    addresses: profileAddressesToAddresses(profile?.addresses),
  };
};

export const prepareJointPayload = (
  caseId: number,
  values: DeclarationFormValues,
  profile?: DeclarationProfileType | null,
): ComplianceJointProfileInput => {
  const hasOwnershipPercentage = values.ownershipPercentage && values.ownershipPercentage > 0;

  return {
    caseId: caseId,
    legalBusinessName: values.legalBusinessName || "",
    accountType: values.accountType as JointAccountTypeEnum,
    amlEntityId: 1,
    relationshipType: profile?.parentRelationships?.map(
      (relationship) => relationship.relationshipType,
    ),
    ...(hasOwnershipPercentage && {
      ownershipPercentage: values.ownershipPercentage,
    }),
    addresses: buildJointDomicileAddresses(profile?.addresses?.[0]?.country?.alpha2code),
  };
};

export const prepareInstitutionPayload = (
  caseId: number,
  values: DeclarationFormValues,
  isSwitchingAccountType: boolean,
  profile?: DeclarationProfileType | null,
): ComplianceInstitutionProfileInput => {
  const hasOwnershipPercentage = values.ownershipPercentage && values.ownershipPercentage > 0;

  return {
    caseId: caseId,
    legalBusinessName: values.legalBusinessName || "",
    accountType: values.accountType as InstitutionAccountTypeEnum,
    dateOfFormation: getSafeDate(profile?.dateOfOrganization),
    taxId: profile?.taxIdUnencrypted,
    taxIdType: profile?.taxIdType,
    amlEntityId: isSwitchingAccountType ? -1 : profile?.amlEntityTypeId,
    relationshipType: profile?.parentRelationships?.map(
      (relationship) => relationship.relationshipType,
    ),
    ...(hasOwnershipPercentage && {
      ownershipPercentage: values.ownershipPercentage,
    }),
    addresses: profileAddressesToAddresses(profile?.addresses),
  };
};
